export default __webpack_public_path__ + "e8d08009c415b738a58167eb4d3c9e43.svg";